import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

/**
 * Layout base FITLAB web — envuelve todas las rutas.
 * Header sticky, main accesible con id="main" (skip link target),
 * Footer con gradiente de marca.
 */
export default function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
